import { Footer, MovieDetails, Navbar } from "../components";

const MovieDetailsPage = () => {
  return (
    <section>
      <Navbar />
      <MovieDetails />
      <Footer />
    </section>
  );
};

export default MovieDetailsPage;
